/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPoint } from '../../models/user-point';

export interface GetLoyaltyUserPoint$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  pointId: string;
  time?: string;
}

export function getLoyaltyUserPoint(http: HttpClient, rootUrl: string, params: GetLoyaltyUserPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoint>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyUserPoint.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.path('pointId', params.pointId, {});
    rb.header('time', params.time, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPoint>;
    })
  );
}

getLoyaltyUserPoint.PATH = '/loyalty/users/{userId}/points/{pointId}';
